var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIStepsWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4556 4.61951C16.1457 5.466 17.3878 7.39206 18.2098 9.16171L7.90163 14.9215L1.50391 14.8387L1.62659 13.4156C1.71859 12.3575 2.39946 11.4435 3.38703 11.054L4.96346 10.4345C5.86822 10.0787 6.63497 9.43774 7.14408 8.60659L8.74198 6.00886C8.88613 5.77577 9.16523 5.65922 9.42899 5.72669C10.3399 5.96285 10.7999 6.26035 11.352 6.51798C12.3396 6.98109 14.1705 6.93202 14.238 5.04276C14.2472 4.7882 14.3852 4.55511 14.6122 4.43856C14.9005 4.29135 15.2532 4.36495 15.4587 4.61645L15.4556 4.61951Z",
    fill: "#3284FF",
    stroke: "white",
    strokeWidth: 1.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.10938 7.62646L8.93116 8.55576",
    stroke: "white",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.18262 9.24146L7.86639 10.1033",
    stroke: "white",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.945 16.043H1.3999C1.12694 16.043 0.90918 15.8222 0.90918 15.5523V15.0033C0.90918 14.7303 1.13 14.5125 1.3999 14.5125H6.94193C7.58293 14.5125 8.2178 14.3623 8.78825 14.074L18.1303 9.36002C18.3726 9.23734 18.6701 9.33548 18.7897 9.57778L19.0381 10.0685C19.1608 10.3108 19.0626 10.6083 18.8204 10.7279L9.47833 15.4418C8.69011 15.8406 7.82216 16.046 6.93886 16.046L6.945 16.043Z",
    fill: "#3284FF",
    stroke: "white",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIStepsWhite);
export default __webpack_public_path__ + "static/media/i_steps_white.11648be5928ddf545fa92504362ea2cb.svg";
export { ForwardRef as ReactComponent };